import Layout from './views/shared/Layout'
import AuthLayout from './views/shared/AuthLayout'
import News from './views/News'
import Reports from './views/Reports'
import ReportEdit from './views/edit/ReportEdit'
import FnsReportEdit from './views/edit/FnsReportEdit'
import NewsDetails from './views/details/NewsDetails'
import SkuDetails from './views/details/SkuDetails'
import MaterialDetails from './views/details/MaterialDetails'
import MaterialFileDetails from './views/details/MaterialFileDetails'
import MaterialFileDetailsMobileApp from './views/details/MaterialFileDetailsMobileApp'
import MaterialTest from './views/details/MaterialTest'
import MaterialTestResults from './views/details/MaterialTestResults'
import MaterialCertificate from './views/details/MaterialCertificate'
import TestOkko from './views/details/TestOkko'
import Login from './views/Login'
import ForgotPassword from './views/ForgotPassword'
import ResetPassword from './views/ResetPassword'
import UserConfirm from './views/UserConfirm'
import Register from './views/Register'
import Projects from './views/Projects'
import ProjectsAppAccess from './views/ProjectsAppAccess'
import ProjectEdit from './views/edit/ProjectEdit'
import Users from './views/Users'
import UserEdit from './views/edit/UserEdit'
import NewsEdit from './views/edit/NewsEdit'
import SkuEdit from './views/edit/SkuEdit'
import MaterialEdit from './views/edit/MaterialEdit'
import RewardEdit from './views/edit/RewardEdit'
import QuestionsEdit from './views/edit/QuestionsEdit'
import FolderEdit from './views/edit/FolderEdit'
import SkuFolderEdit from './views/edit/SkuFolderEdit'
import RewardFolderEdit from './views/edit/RewardFolderEdit'
import Activation from './views/Activation'
import TasksEdit from './views/edit/TasksEdit'
import TasksDetails from './views/details/TasksDetails'
import TasksAnswerEdit from './views/edit/TasksAnswerEdit'

import Analytics from './views/Analytics'
import Materials from './views/Materials'
import Motivation from './views/Motivation'
import Rating from './views/RatingNew'
import Sellers from './views/Sellers'
import Sku from './views/Sku'
import SpendBonuses from './views/SpendBonuses'
import TradePoints from './views/TradePoints'
import Profile from './views/Profile'
import Roles from './views/Roles'
import Cart from './views/Cart'
import Orders from './views/Orders'
import BonusHistory from './views/BonusHistory'
import FaqPage from './views/FaqPage'
import Sender from './views/Sender'
import Tasks from './views/Tasks'
import TasksTable from './views/TasksTable'
import MyProgress from "./views/MyProgress.vue";

const routes = [
    {
        path: '/',
        component: Layout,
        children: [
            {
                path: 'news',
                alias: '',
                name: 'news',
                component: News
            },
            {
                path: 'news/:id',
                name: 'newsDetails',
                component: NewsDetails
            },
            {
                path: 'news/edit/:id',
                name: 'newsEdit',
                component: NewsEdit
            },
            {
                path: 'projects',
                name: 'projects',
                component: Projects
            },
            {
                path: 'projects/appaccess',
                name: 'projectsAppAccess',
                component: ProjectsAppAccess
            },
            {
                path: 'projects/:id',
                name: 'projectEdit',
                component: ProjectEdit
            },
            {
                path: 'materials',
                name: 'materials',
                component: Materials
            },
            {
                path: 'materials/edit/:id',
                name: 'materialEdit',
                component: MaterialEdit
            },
            {
                path: 'materials/edit/:id/questions',
                name: 'questionsEdit',
                component: QuestionsEdit
            },
            {
                path: 'materials/certificate/:projectId',
                name: 'materialCertificate',
                component: MaterialCertificate
            },
            {
                path: 'materials/:id',
                name: 'materialDetails',
                component: MaterialDetails
            },
            {
                path: 'materials/:materialId/:id(\\d+)',
                name: 'materialFileDetails',
                component: MaterialFileDetails
            },
            {
                path: 'materials/:id/test',
                name: 'materialTest',
                component: MaterialTest
            },
            {
                path: 'materials/:id/testresults',
                name: 'materialTestResults',
                component: MaterialTestResults
            },
            {
                path: 'materials/:id/okko',
                name: 'materialTestOkko',
                component: TestOkko
            },
            {
                path: 'materials/folder/edit/:id',
                name: 'folderEdit',
                component: FolderEdit
            },
            {
                path: 'reports',
                name: 'reports',
                component: Reports
            },
            {
                path: 'reports/:id(\\d+)',
                name: 'ReportEdit',
                component: ReportEdit
            },
            {
                path: 'reports/fns/:id',
                name: 'FnsReportEdit',
                component: FnsReportEdit
            },
            {
                path: 'rating',
                name: 'rating',
                component: Rating
            },
            {
                path: 'spend-bonuses',
                name: 'spend-bonuses',
                component: SpendBonuses
            },
            {
                path: 'bonus-history',
                name: 'bonus-history',
                component: BonusHistory
            },
            {
                path: 'rewards/edit/:id',
                name: 'rewardEdit',
                component: RewardEdit
            },
            {
                path: 'rewards/folder/edit/:id',
                name: 'rewardFolderEdit',
                component: RewardFolderEdit
            },
            {
                path: 'analytics',
                name: 'analytics',
                component: Analytics
            },
            {
                path: 'sellers',
                name: 'sellers',
                component: Sellers
            },
            {
                path: 'sku',
                name: 'sku',
                component: Sku
            },
            {
                path: 'sku/edit/:id',
                name: 'skuEdit',
                component: SkuEdit
            },
            {
                path: 'sku/:id',
                name: 'skuDetails',
                component: SkuDetails
            },
            {
                path: 'sku/folder/edit/:id',
                name: 'skuFolderEdit',
                component: SkuFolderEdit
            },
            {
                path: 'motivation',
                name: 'motivation',
                component: Motivation
            },
            {
                path: 'projects/:projectId/users',
                name: 'users',
                component: Users
            },
            {
                path: 'projects/:projectId/users/:userName',
                name: 'UserEdit',
                component: UserEdit
            },
            {
                path: 'projects/:projectId/trade-points',
                name: 'trade-points',
                component: TradePoints
            },
            {
                path: 'projects/:projectId/roles',
                name: 'roles',
                component: Roles
            },
            {
                path: 'profile',
                name: 'profile',
                component: Profile
            },
            {
                path: 'cart',
                name: 'cart',
                component: Cart
            },
            {
                path: 'orders',
                name: 'orders',
                component: Orders
            },
            {
                path: 'faq',
                name: 'faq',
                component: FaqPage
            },
            {
                path: 'sender',
                name: 'sender',
                component: Sender
            },
            {
                path: 'tasks',
                name: 'tasks',
                component: Tasks
            },
            {
                path: 'tasks/table',
                name: 'tasksTable',
                component: TasksTable
            },
            {
                path: 'tasks/edit/:projectId/:id',
                name: 'tasksEdit',
                component: TasksEdit
            },
            {
                path: 'tasks/:id',
                name: 'tasksDetails',
                component: TasksDetails
            },
            {
                path: 'tasks/answer/:taskId/:answerId/:edit',
                name: 'tasksAnswerEdit',
                component: TasksAnswerEdit
            },
            {
                path: 'my-progress',
                name: 'myProgress',
                component: MyProgress
            },
        ]
        // beforeEnter: (to, from, next) => {
        //     console.info('beforeEnter', )
        // }
    },
    {
        path: '/',
        component: AuthLayout,
        children: [
            {
                path: 'login',
                name: 'login',
                component: Login
            },
            {
                path: 'forgot',
                name: 'forgot',
                component: ForgotPassword
            },
            {
                path: 'user/reset/:hash',
                name: 'reset',
                component: ResetPassword
            },
            {
                path: 'user/confirm/:hash',
                name: 'confirm',
                component: UserConfirm
            },
            {
                path: 'register',
                name: 'register',
                component: Register
            },
            {
                path: 'user/activation/:hash',
                name: 'activation',
                component: Activation
            }
        ]
    },
    {
        path: '/urltoken/materials/:materialId/:id(\\d+)',
        name: 'MaterialFileDetailsMobileApp',
        component: MaterialFileDetailsMobileApp
    }
];

export default routes;

function requireAuth (to, from, next) {
    // if (!auth.loggedIn()) {
    //     next({
    //         path: '/login',
    //         query: { redirect: to.fullPath }
    //     })
    // } else {
    //     next()
    // }
    // next({
    //     path: '/login',
    //     query: {redirect: to.fullPath}
    // })
    next()
}




// WEBPACK FOOTER //
// ./Content/src/routes.js